import React from 'react';
import { useTranslator, useUrlLocalizer } from 'tradera-lang/translate';
const TopLevelCategories = ({ topLevelCategories }) => {
    return topLevelCategories?.map(c => (
        <a key={c.id} href={c.href}>
            {c.title}
        </a>
    ));
};

const SeoLinks = ({ isLoggedIn, topLevelCategories }) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    return (
        <div className="hidden">
            {topLevelCategories?.length >= 0 && (
                <TopLevelCategories topLevelCategories={topLevelCategories} />
            )}
            {!isLoggedIn && (
                <a href={toLocalizedUrl('/inspiration')}>
                    {t('siteHeader_inspiration')}
                </a>
            )}
        </div>
    );
};

export { SeoLinks };
